import { render, staticRenderFns } from "./ProductTable.vue?vue&type=template&id=06fbf7fc"
import script from "./ProductTable.vue?vue&type=script&lang=js"
export * from "./ProductTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports